//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/TaggedObjectCollection.js";
import "../Routing/Routing.RouteManager.js";
let d=[[],[[["mode","reason","objs","num_violations"],"ReasonExecuteRule",{R_:{violations:"Routing.DesignRuleViolation[]"}},3,0]],[]];
SPLM.Routing.DesignRuleViolationCollection = class extends SPLM.TaggedObjectCollection{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Routing.DesignRuleViolationCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
    ToArray(context)
    {
        let r={};
        if(context === undefined){
            r.ToArray={"context":this._d.ObjectId};
        }
        else{
            r.ToArray={"context":context};
        }
        r.Class=this._d.Class;
        if(SPLM.api === undefined){
            this._d.ToArray=r.ToArray;
        }
        else{
            SPLM.api.push(r);
        }
        return r;
    }
};

SPLM.Routing.DesignRuleViolationCollection.Mode = Object.freeze({
    "Concurrent" : "Concurrent", "Interactive" : "Interactive", "Batch" : "Batch"});

SPLM.Routing.DesignRuleViolationCollection.Reason = Object.freeze({
    "Unknown" : "Unknown", "CreatePath" : "CreatePath", "HealPath" : "HealPath", "AssignCorner" : "AssignCorner", "AssignStock" : "AssignStock", "RemoveStock" : "RemoveStock", "StockStyle" : "StockStyle", "PlacePart" : "PlacePart", "CreateFab" : "CreateFab", "QualifyPart" : "QualifyPart", "MovePath" : "MovePath", "CopyPath" : "CopyPath", "DeletePath" : "DeletePath", "SubdivideSeg" : "SubdivideSeg", "SimplifyPath" : "SimplifyPath", "RemovePart" : "RemovePart", "MovePart" : "MovePart", "EditCharx" : "EditCharx", "Interactive" : "Interactive", "Batch" : "Batch", "OrientStock" : "OrientStock", "UnifyPath" : "UnifyPath", "TransformPath" : "TransformPath", "OffsetPath" : "OffsetPath", "AutoRoutePin" : "AutoRoutePin", "ManualRoutePin" : "ManualRoutePin", "AutoRouteComp" : "AutoRouteComp", "ManualRouteComp" : "ManualRouteComp", "Import" : "Import", "PartialAutoRouteComp" : "PartialAutoRouteComp", "EditPlacePart" : "EditPlacePart", "BulkReplacement" : "BulkReplacement"});

export default SPLM;